import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import * as Social from 'components/social'
import * as Links from 'components/links'
import * as Page from 'components/page'
import { ButtonSet } from './Navigation'
import * as MIN from 'utils/min'

Success.propTypes = {
    submissionID: PropTypes.string.isRequired,
    ownsObservations: PropTypes.bool.isRequired,
    username: PropTypes.string,
}

export default function Success({ submissionID, ownsObservations, username }) {
    const description = 'Mountain Information Network - Form / Success'
    const urls = Social.createShareUrls(MIN.shareUrl(submissionID))
    const href = Links.mountainInformationNetwork(submissionID)

    if (ownsObservations) {
        return (
            <section>
                <h2>
                    <FormattedMessage
                        description={description}
                        defaultMessage="Thanks for using the Mountain Information Network!"
                    />
                </h2>
                <Page.Headline>
                    <FormattedMessage
                        description={description}
                        defaultMessage="Your observations have been submitted. Do not forget to share your observations."
                    />
                </Page.Headline>
                <ButtonSet>
                    <Links.Button large href={`/account/submissions/${submissionID}/edit`}>
                        <FormattedMessage
                            description={description}
                            defaultMessage="Edit my report"
                        />
                    </Links.Button>
                    <Social.Set>
                        {urls.map(url => (
                            <Social.Item key={url} link={url} />
                        ))}
                    </Social.Set>
                    <Links.Button large href={href}>
                        <FormattedMessage
                            description={description}
                            defaultMessage="View my report"
                        />
                    </Links.Button>
                </ButtonSet>
            </section>
        )
    }

    return (
        <section>
            <h2>
                <FormattedMessage
                    description={description}
                    defaultMessage="Observations made by {username} have been submitted."
                    values={{ username }}
                />
            </h2>
            <Links.Button large href={href}>
                <FormattedMessage description={description} defaultMessage="View the report" />
            </Links.Button>
        </section>
    )
}
